import Pokemon from './pokemon/Pokemon';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

function App() {
  return (
    <div className="container-fluid p-0">
     <Pokemon />
    </div>
  );
}

export default App;
